// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"tooltip-wrapper_tooltipWrapper__Cbjsq","tooltip":"tooltip-wrapper_tooltip__sDSG6","hover":"tooltip-wrapper_hover__-UmDY"};